function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M12 16.8l-5.878 4.29 2.264-6.916L2.489 10h7.277L12 3l2.234 7h7.277l-5.897 4.174 2.264 6.916z",
  fill: "currentColor",
  fillRule: "evenodd"
});

var SvgLocationAttraction = function SvgLocationAttraction(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
};

export default SvgLocationAttraction;